module.exports = __webpack_public_path__ + "img/count_down1.d374b6df.png";